import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { GeneralRoutePaths } from '../enums/route-types.enum';
import { isMobile } from '../util/feature-detection.helper';

export const mobileDeviceGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean | Observable<boolean | UrlTree> => {
  const router = inject(Router);

  if (!isMobile()) {
    router.navigate(['/', GeneralRoutePaths.PAGE_NOT_FOUND]);
    return false;
  }

  return true;
};
